import { FunctionComponent } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthPage from "./auth";
import DashboardPage from "./dashboard";
import ConfiguratorsPage from "./configurators";
import { useUser } from "hooks/useUser";
import { ROUTES } from "constants/routes";
import ModelsPage from "./models";
import MaterialsPage from "./materials";
import ConfiguratorPage from "./configurator";

interface PagesProps {
  basename?: string;
}

const Pages: FunctionComponent<PagesProps> = ({ basename }) => {
  const user = useUser();
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={user ? <DashboardPage /> : <AuthPage />}>
          <Route path={ROUTES.configurators} element={<ConfiguratorsPage />} />
          <Route path={ROUTES.models} element={<ModelsPage />} />
          <Route path={ROUTES.materials} element={<MaterialsPage />} />
          <Route path={ROUTES.configurator} element={<ConfiguratorPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
export default Pages;
